import { useState } from 'react';
import { faqs } from '@/mocks/articles';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            <a href="#faq-section" className="hover:text-primary-500 transition-colors">常见问题</a>
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于《玉蒲团》研究的常见问题与解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/60 transition-colors duration-200"
                onClick={() => toggleFaq(index)}
                aria-expanded={openIndex === index}
              >
                <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`flex-shrink-0 text-foreground-400 transition-transform duration-200 text-sm ${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}